import { IItem } from './interface';
import { log } from '../../../../utils/logger';

export const stringifyItem = (item: IItem | null) =>
    item ? item.title + (item.count ? ` (${item.count})` : '') : '';

export const getFilteredItems = function(filter: string | null, items: IItem[]): IItem[] {
    if (!filter) return items;
    if (!items?.length) {
        log.warn(`Passed items to getFilteredItems is not an array or it's empty`);
        return [];
    }
    const filteredItems = items.filter(item =>
        stringifyItem(item)
            .toLowerCase()
            .includes(filter.toLowerCase()),
    );
    return filteredItems;
};
